import { forwardRef } from 'react';
import MuiRating from '@mui/material/Rating';

export type RatingProps = {
  value?: number | null;
  onChange?: (value: number | null) => void;
  /** Number of stars. @default 5 */
  max?: number;
  readOnly?: boolean;
  disabled?: boolean;
  size?: 'small' | 'medium' | 'large';
  name?: string;
};

/** Design-system Rating — wraps MUI Rating. */
export const Rating = forwardRef<HTMLSpanElement, RatingProps>(function Rating(
  { value, onChange, max = 5, readOnly = false, disabled = false, size = 'medium', name },
  ref
) {
  return (
    <MuiRating
      ref={ref}
      className="SmRating-root"
      name={name}
      value={value ?? null}
      max={max}
      readOnly={readOnly}
      disabled={disabled}
      size={size}
      onChange={(_e, newValue) => onChange?.(newValue)}
    />
  );
});
